import { render, staticRenderFns } from "./EditChunkModal.vue?vue&type=template&id=badc7414&"
import script from "./EditChunkModal.vue?vue&type=script&lang=js&"
export * from "./EditChunkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('badc7414')) {
      api.createRecord('badc7414', component.options)
    } else {
      api.reload('badc7414', component.options)
    }
    module.hot.accept("./EditChunkModal.vue?vue&type=template&id=badc7414&", function () {
      api.rerender('badc7414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/viewKnowledge/documents/components/EditChunkModal.vue"
export default component.exports